<template>
  <div class="scoreListWrap">
    <div class="inviteMessage">
      <div class="peopleWrap">
        <div class="num">{{inviteNum ? inviteNum : 0}}</div>
        <div :class="`text ${isNight ? 'text_dark' : ''}`">{{ $t("inviteDetail.invitations") }}</div>
      </div>
      <div class="cutLine"></div>
      <div class="cashWrap">
        <div class="num">{{inviteTotalScore ? symbol + inviteTotalScore : symbol + 0}}</div>
        <div :class="`text ${isNight ? 'text_dark' : ''}`" :style="style">{{ $t("inviteDetail.cash") }}</div>
      </div>
    </div>
    <div class="withdrawWrap">
      <a class="withdrawButton" @click="openWithdraw">
        {{ $t("inviteDetail.toWithdraw") }}
      </a>
    </div>
    <div :class="`recordHeader ${isNight ? 'recordHeader_dark' : ''}`">
      <div class="recordHeaderText">
        {{ $t("inviteDetail.invitationRecord") }}
      </div>
    </div>
    <div :class="`cutLineWrap ${isNight ? 'cutLineWrap_dark' : ''}`">  
    </div>
    <div :class="`listNone ${isNight ? 'listNone_dark' : ''}`" v-if="listData.length === 0">
      <div class="noneText">{{ $t("inviteDetail.noRecord") }}</div>
   </div>
    <van-list
      class="listWrap"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      v-if="listData.length >= 1"
    >
      <div class="item" v-for="item in listData" :key="item.sort">
        <div class="itemDescWrap">
          <div :class="`itemName ${isNight ? 'itemName_dark' : ''}`">
            {{ item.userName }}
          </div>
          <div :class="`itemTime ${isNight ? 'itemTime_dark' : ''}`">
            {{ item.operateTime }}
          </div>
        </div>
        <div :class="`itemNum ${isNight ? 'itemNum_dark' : ''}`">
          + {{ symbol + item.score / 100 }}
        </div>
      </div>
      <div class="footerWrap" v-if="listData.length > 5"></div>
      <div :class="`inviteMore ${isNight ? 'inviteMore_dark' : ''}`" v-if="listData.length === 1">
        <div class="moreText">{{ $t("inviteDetail.firstInvite") }}</div>
      </div>
      <slot name="loading" v-if="loading">
        <compLoading />
      </slot>
    </van-list>
  </div>
</template>

<script>
import compLoading from "@src/components/loading";
import { getLang } from '@src/utils/util.js'

export default {
  components: {
    compLoading,
  },
  props: ["totalScore", "symbol", "listData","inviteNum", "inviteTotalScore","type", "isNight", "loadings", "end",],
  data() {
    return {
      loading: this.loadings,
      finished: this.end,
      style:{}
    };
  },
  beforeUpdate() {
    //解决loading一直出现问题
    this.finished = this.end;
    this.loading = this.loadings;
  },
   mounted(){
     if(getLang() === "vi-VN"){
       this.style = "fontSize:0.36rem"
     }
   },
  methods: {
    onLoad() {
      // console.log("loadMore");
      console.log("loading", this.loading);
      this.$emit("loadMore");
    },
    openWithdraw() {
      this.$emit("toWithdraw");
    }
  },
};
</script>

<style lang="stylus" scoped>
.scoreListWrap {
  // padding: 0.3rem 0.72rem 0.9rem;
  .inviteMessage {
    display: flex;
    justify-content: center;
    align-items: center;
    margin 0.48rem 0.48rem 0
    .peopleWrap {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 3.96rem;
      margin-right: 0.48rem;
    }
    .num {
      height: 1.02rem;
      color: #FD8326;
      font-size: 0.72rem;
      width: 100%;
      margin-bottom: 0.18rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .text {
      height: 0.6rem;
      color: rgba(0, 0, 0, 0.55);
      font-size: 0.42rem;
      line-height: 0.6rem;
    }
    .text_dark {
      color: rgba(255, 255, 255, 0.55);
    }
    .cutLine {
      height: 0.9rem;
      width: 0.02rem;
      background-color: rgba(0, 0, 0, 0.12);
    }
    .cashWrap {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 3.96rem;
      margin-left: 0.48rem;
    }
  }
  .withdrawWrap {
    margin 0.6rem 0.48rem 0
  }
 .withdrawButton {
    margin: 0 auto;
    justify-content: center;
    display: flex;
    align-items: center;
    background: #fd8326;
    border-radius: 1.08rem;
    width:4.56rem;
    height: 1.32rem;
    border: none;
    color: #ffffff;
    font-family: 'OPPOSans 2.14 NoVF';
    font-weight: 500;
    font-size: 0.42rem;
  }
  .recordHeader {
    height 1.56rem
    // line-height 1.56rem 
    color: rgba(0, 0, 0, 0.85)
    font-size 0.48rem 
    font-weight 500
    margin 0.6rem 0.48rem 0
    width:8.88rem
  }
  .recordHeader_dark {
    color:rgba(255, 255, 255, 0.85);
  }
  .recordHeaderText{
    height:0.69rem;
    line-height :0.69rem;
    padding-top :16.5px;
  }
  .cutLineWrap {
    height 0.01rem
    background-color rgba(0, 0, 0, 0.12)
    margin: 0 0.48rem 0rem
  }
  .cutLineWrap_dark {
    background-color:rgba(255, 255, 255, 0.2);
   }
  .listNone {
    display: flex;
    // margin-top 2.82rem
    margin 2.82rem 0.48rem 0
    text-align center
    flex-direction: column;
    color: rgba(0, 0, 0, 0.3);
    .noneText{
      height:1.02rem;
      word-break:keep-all
      line-height :0.51rem;
      font-size:0.36rem
    }
  }
  .listNone_dark {
    color: rgba(255, 255, 255, 0.3);
  }
  .inviteMore {
    margin-top 2.22rem
    text-align center
    color: rgba(0, 0, 0, 0.3);
    .moreText{
      height:1.02rem;
      line-height :0.51rem;
      word-break:keep-all
      font-size:0.36rem;
      width:8.88rem
      margin: 0 0.48rem;
    }
  }
  .inviteMore_dark {
      color: rgba(255, 255, 255, 0.3);
  }
  .listWrap {
    .footerWrap {
      height:0.3rem
    }
    .item {
      display: flex;
      flex-direction: row;
      height: 1.56rem;
      width:9.84rem;
      .itemDescWrap {
        text-align: left;
        display: flex;
        flex-direction: column;
        width: 6.6rem;
        height: 1.56rem;
        margin-left :0.48rem;
        justify-content: center;
        .itemName {
          width: 100%;
          font-size: 0.42rem;
          font-family: 'OPPOSans 2.14 NoVF';
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 0.06rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 0.6rem;
          line-height 0.6rem;
        }
        .itemName_dark {
          color: rgba(255, 255, 255, 0.85);
        }
        .itemTime {
          width: 100%;
          font-size: 0.36rem;
          height: 0.51rem;
          line-height 0.51rem
          color: rgba(0, 0, 0, 0.3);
        }
        .itemTime_dark {
          color: rgba(255, 255, 255, 0.3);
        }
      }
      .itemNum {
        display: flex;
        height: 100%;
        align-items: center;
        flex: 1;
        justify-content: flex-end;
        font-family: 'OPPOSans 2.14 NoVF';
        font-size: 0.42rem;
        color: rgba(0, 0, 0, 0.85);
        margin-right :0.48rem
      }
      .itemNum_dark {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/inviteList.vue